import { render } from "./Layout.vue?vue&type=template&id=dc4edde4&scoped=true&ts=true"
import script from "./Layout.vue?vue&type=script&lang=ts"
export * from "./Layout.vue?vue&type=script&lang=ts"

import "./layout.scss?vue&type=style&index=0&id=dc4edde4&lang=scss&scoped=true"
import "./layout-global.scss?vue&type=style&index=1&lang=scss"

import exportComponent from "C:\\xampp\\htdocs\\Peaco-v.1\\PEACO\\peacohrm-main\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc4edde4"]])

export default __exports__